export default {
  SET_documentLanguage(state, value) {
    state.documentLanguage = value;
  },
  SET_defaultFromPhoneNumber(state, value) {
    state.defaultFromPhoneNumber = value;
  },
};
